import React from 'react';
import Navigation from './navigation';
import Heading from './heading';
import Footer from './footer';
import Typography from '@mui/material/Typography';

import Chaturmasa20251 from '../images/chaturmasa/2026/1.PNG';
import Chaturmasa20252 from '../images/chaturmasa/2026/2.PNG';
import Chaturmasa20253 from '../images/chaturmasa/2026/3.PNG';
import Chaturmasa20254 from '../images/chaturmasa/2026/4.PNG';

import { 
    CardGroup, 
    Row, 
    Card, 
    CardBody, 
    CardText, 
    CardTitle, 
    Button, 
    Col, 
    CardHeader,
    ListGroup,
    ListGroupItem
} from 'reactstrap';

function Mission(){
    return (
        <div>
            <Navigation/>
            <Heading/>
            <hr/>
            <h2 style={{textAlign:'center'}}>Chaturmasya 2026 @ Bagalkot</h2>
            <Row>
                <Col sm="1"></Col>
                <Col sm="6">
                    <Card
                        className="my-2"
                        color="warning"
                        outline
                    > 
                        <CardBody className="my-2" color="warning" style={{textAlign:'center'}}>           
                            <CardText style={{paddingTop:5}}>
                            </CardText>
                            <img className='rounded'
                              alt="Chaturmasya 2026 Page Main Page"
                              src={Chaturmasa20251}
                              style={{height:'auto', width:'350px'}}
                            />
                            <br/>
                            <br/>
                            <img className='rounded'
                              alt="Chaturmasya 2026 Page Main Page"
                              src={Chaturmasa20252}
                              style={{height:'auto', width:'350px'}}
                            />
                            <br/>
                            <br/>
                            <img className='rounded'
                              alt="Chaturmasya 2026 Page Main Page"
                              src={Chaturmasa20253}
                              style={{height:'auto', width:'350px'}}
                            />
                            <br/>
                            <br/>
                            <img className='rounded'
                              alt="Chaturmasya 2026 Page Main Page"
                              src={Chaturmasa20254}
                              style={{height:'auto', width:'350px'}}
                            />
                            <br/>
                            <br/>
                        </CardBody>
                    </Card>
                </Col>
                <Col sm="5">
                    <Card
                        className="my-2"
                        color="warning"
                        outline
                    > 
                        <CardBody className="my-2" color="warning">           
                            <CardText style={{paddingTop:5}}>
                            <Typography id="modal-modal-title" variant="h6" component="h2" style={{textAlign:'center'}}>
                              || Shree Vaikunta Seeta Raamchandro Vijayate ||
                            </Typography>
                            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                              The 24th Chaturmasya of Shree Shree 1008 Shree RaghuVijaya Teertha Swamiji 
                              will be held at Shree Uttaradhimutt, Navanagar, 
                              Bagalkot from 08th Aug to 25th Sep 2026.
                              <br/><br/>
                              <b>Venue:</b><br/>
                              Shree Uttaradhimutt<br/>
                              Navanagar<br/>
                              Bagalkot<br/>
                              <br/>
                              <br/>
                              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3831.974359814469!2d75.65024882379896!3d16.170272536727644!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc77911003628c1%3A0xd2deb087c7a64c6b!2sShri%20Satyabodharaya%20Math%20-%20Shri%20Uttaradi%20Math%2C%20Bagalkote!5e0!3m2!1sen!2sin!4v1785057197481!5m2!1sen!2sin" width="400" height="200" style={{ border: "none" }} allowfullscreen="" loading="lazy" referrerpolicy="strict-origin-when-cross-origin"></iframe>
                              <br/>
                              <br/>
                              <b>Key Dates:</b><br/>
                              <ul>
                                <li><p>Pura pravesha and swagata (welcome procession): 07th Aug 2026 (evening)</p></li>
                                <li><p>Chaturmasya Sankalpa: 08 Aug 2026</p></li>
                                <li><p>Nagapanchami: 16 Aug 2026</p></li>
                                <li><p>Upakarma: 26 Aug 2026</p></li>
                                <li><p>Shree Raghunath Teerthara Aaradhane: 28 Aug 2026</p></li>
                                <li><p>Shree Krishna Janmastami & Shree Ragottama Teerthara Aaradhane: 04 Sep 2026</p></li>
                                <li><p>Shree RaghuPrema Teerthara Aaradhane: 12 Sep 2026</p></li>
                                <li><p>Shree Ganesha Chaturthi: 14 Sep 2026</p></li>
                                <li><p>Shree RaghuDaant Teerthara Aaradhane: 18 Sep 2026</p></li>
                                <li><p>Chaturmasa Samaropa Samarambha : 24 Sep 2026</p></li>
                                <li><p>Seemollanghana & Shree RaghuVandya Teerthara Aaradhane : 26 Sep 2026 </p></li>
                              </ul>
                              
                            </Typography>
                            <p>
                              Each day, the Kudlimath resonates with spiritual activities such as parayana, patha, pravachana, bhajane, 
                              paada puje, samsthana pooje, teertha prasada, and sangeeta seva, culminating in the divine 
                              amrutopadesha from Sripadangalavaru. Weekends and special days are further enriched with 
                              jnana satra, workshops, dasa vaani, and other enriching programs.
                            </p>
                            <p>
                              Please visit, <a href="https://www.kudlimath.in">https://www.kudlimath.in</a> for the more information, invitation, location and to offer online seva.
                            </p>
                            <p>
                              We extend a heartfelt welcome to all devotees, encouraging their participation in our 
                              various programs to cultivate Jnana, Bhakti, and Vairagya.
                            </p>
                            <p>Regards,<br/>
                              Divanaru, <br/>Shree Kudli Arya Akshobhyateerth Math.
                            </p>
                          </CardText>
                            
                        </CardBody>
                    </Card>
                </Col>
                
            </Row>

            <Footer/>
        </div>
    );
}

export default Mission;